import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Screen, Spinner, Tabs, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton } from '~/commonComponents';
import { getWorkerClassificationManagement } from '../../actions';
import { createLoadingSelector } from '../../api/selectors';
import { Colors } from '../../themes/colors';
import { ConfirmedWorkerType } from './ConfirmedWorkerType/ConfirmedWorkerType';
import { PendingRequests } from './PendingRequests/PendingRequests';
import { Unselected } from './Unselected/Unselected';
import { getInitialTab } from './utils';

const loadingSelector = createLoadingSelector(['GET_WORKER_CLASSIFICATION_MANAGEMENT']);

export function WorkerClassificationManagement() {
  const dispatch = useDispatch();
  const requests = useSelector((state) => state.user.workerClassificationManagement);
  const isLoading = useSelector((state) => loadingSelector(state));
  // Controlled: requests load asynchronously, so the active tab must re-sync
  // when getInitialTab(requests) changes after mount (legacy Tabs did this via
  // its own useEffect on initialTab; DS Tabs defaultValue only applies once).
  const [activeTab, setActiveTab] = useState('unselected');

  useEffect(() => {
    setActiveTab(getInitialTab(requests));
  }, [requests]);

  useEffect(() => {
    dispatch(getWorkerClassificationManagement());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Worker Type Management" />
      <Screen.Body>
        <Typography
          as="span"
          italic
          color={colors.neutral[500]}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 50,
            gap: 2,
          }}
        >
          For more information about what worker type is,
          <a
            href="https://lp.joingotu.com/workerclassification"
            target="_blank"
            rel="noreferrer"
            style={{
              fontFamily: 'Nunito',
              color: Colors.secondary_500,
              fontWeight: 700,
              textDecoration: 'none',
              fontStyle: 'normal',
            }}
          >
            Click here
          </a>
          .
        </Typography>

        {isLoading ? (
          <Spinner centered variant="default" size="md" />
        ) : (
          <div style={{ width: '80%', alignSelf: 'center', marginBottom: 120 }}>
            <Tabs defaultValue="unselected" value={activeTab} onValueChange={setActiveTab}>
              <Tabs.List>
                <Tabs.Tab
                  value="unselected"
                  label={
                    requests?.unselected?.length > 10
                      ? '10+'
                      : requests?.unselected?.length > 0
                        ? String(requests.unselected.length)
                        : undefined
                  }
                >
                  Unselected
                </Tabs.Tab>
                <Tabs.Tab
                  value="pending-requests"
                  label={
                    requests?.pending?.length > 10
                      ? '10+'
                      : requests?.pending?.length > 0
                        ? String(requests.pending.length)
                        : undefined
                  }
                >
                  Pending Requests
                </Tabs.Tab>
                <Tabs.Tab value="confirmed">Confirmed Worker Type</Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="unselected" style={{ width: '100%' }}>
                <Unselected />
              </Tabs.Panel>
              <Tabs.Panel value="pending-requests" style={{ width: '100%' }}>
                <PendingRequests />
              </Tabs.Panel>
              <Tabs.Panel value="confirmed" style={{ width: '100%' }}>
                <ConfirmedWorkerType />
              </Tabs.Panel>
            </Tabs>
          </div>
        )}
      </Screen.Body>
    </Screen>
  );
}
